let header = document.querySelector('sticky-header'); 
  
  let headerHeight = header.offsetHeight; 
  document.querySelectorAll('ul.table-of-contents li a[href^="#"]') 
  .forEach(function (anchor) { 
      anchor.addEventListener('click',  
      function (event) { 
          event.preventDefault(); 

          let target = document.querySelector( 
              this.getAttribute('href') 
          ); 
            
          let targetPosition = target 
              .getBoundingClientRect().top - headerHeight; 

          window.scrollTo({ 
              top: targetPosition + window.scrollY, 
              behavior: 'smooth' 
          }); 
      }); 
  }); 